import styles from "./styles.module.css";
import { FontProps } from "../types";
import { Paragraph } from "fonts/Paragraph";

export const TextBody2 = (props: FontProps) => Paragraph({ styles, ...props });
